<template>
  <div class="mh bg-main">
    <!-- 背景图片 -->
    <div class="bg">
      <div class="bgImg">
        <div class="pageTitle">在线报读平台</div>
        <img src="@/assets/img/bjing@2x.png" alt="" />
      </div>
      
    </div>
    <div class="contentWrap">
      <!--  步骤条 -->
      <ul class="stepDiv h85">
        <li class="stepItem" v-for="(item,index) in stepList" :key="index">
          <!-- 小圆图标 -->
          <div v-if="stepActive >= index" class="iconClass pr">
            <img src="@/assets/img/jindu.png">
            <div class="patitle">{{item}}</div>
          </div>
          <div v-else class="pr" >
            <div class="cricle"></div>
            <div class="patitle">{{item}}</div>
          </div>
          <div v-if="index+1 != stepList.length" :class="[{'line': true},{'activeLine':stepActive-1 >= index }]"></div>
        </li>
      </ul>
      <!-- 表单信息 -->
      <div>
        <Homes v-show="stepActive === 0" ref="home" :openId="openId" :stepActive="0"></Homes>
        <improveInfor v-show="stepActive === 1" ref="improveInfor" :openId="openId" :stepActive="stepActive"></improveInfor>
        <sign v-show="stepActive == 2" ref="sign" :openId="openId" :stepActive="stepActive"></sign>
      </div>
    </div>
    <div class="next" v-if="stepActive != 2">
      <van-button class="prevBtn" block plain @click.stop.prevent="prevClick" v-if="stepActive == 1">上一步</van-button>
      <van-button type="info" block class="nextBtn" @click.stop.prevent="nextClick">下一步</van-button>
    </div>
    <div class="next" v-else>
      <van-button class="prevBtn" block @click.stop.prevent="prevClick">上一步</van-button>
      <van-button
        v-if="!isDisabled"
        class="prevBtn"
        block
        native-type="submit"
        @click.prevent="clickReplay"
        >清除重写</van-button>
      <van-button
        block
        v-if="!isDisabled"
        type="info"
        native-type="submit"
        class="nextBtn"
        @click.prevent="nextClick"
        >签名确认</van-button>
    </div>
  </div>
</template>
<script>
import Homes from './Home.vue'
import improveInfor from './improveInfor'
import sign from '../Sign/Sign'
export default {
  name: "index",
  data() {
    return {
      stepActive: 0,
      isDisabled: false,
      stepList: ['预报读','资料审核','注册学籍']
    };
  },
  watch: {
    $route(val) {
      if(val.params.type) {
        window.location.reload(); //监测到路由发生跳转时刷新一次页面
      }
    },
  },
  components: {Homes,improveInfor,sign},
  created() {
    this.openId = this.$route.query.openId
    this.$store.commit('setOpenId', this.openId);
  },
  
  methods:{
    nextClick() {
      if (this.stepActive === 0) {
        this.$refs.home.onSubmit().then(res=>{
          this.isDisabled = res
          this.stepActive ++
        }).catch(err=>{
          console.log('第一步提交失败:', err);
        })
      }else if (this.stepActive == 1) {
        this.$refs.improveInfor.onSubmit().then(res=>{
          this.stepActive ++
        }).catch(err=>{
          console.log('第二步提交失败:', err);
        })
      }else if (this.stepActive == 2) {
        this.$refs.sign.onSubmit().catch(err=>{
          console.log('签名提交失败:', err);
        })
      }
    },
    // 上一步
    prevClick() {
      this.stepActive --
    },
    // 签名取消
    clickReplay() {
      this.$refs.sign.clickReplay()
    }
  }

};
</script>

<style scoped>
/* 背景图片 */
.bgImg {
  position: relative;
  width: 100%;
  height: 272px;
  z-index: 0;
}
.bgImg img {
  width: 100%;
  height: 100%;
}
.bgImg .pageTitle {
  position: absolute;
  top: 82px;
  left: 26px;
  font-size: 25px;
  font-weight: bold;
  color: #FFFFFF;
}

.appName {
  width: 171px;
  background-color: #ffffff4b;
  text-align: center;
  height: 24px;
  line-height: 24px;
  border-radius: 40px;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  position: absolute;
  top: 104px;
  left: 50%;
  transform: translate(-50%, 0);
}
.contentWrap {
  position: relative;
  margin-top: -5px;
  padding: 0 10px 10px;
  top: -138px;

}

/* 步骤条 */
.h85 {
  height: 85px;
}
.stepDiv{
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 15px;
  padding: 20px;
  margin: 0 auto;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.stepItem{
  height: 18px;
  width: 100%;
  flex: 1;
  justify-content: center;
  display: flex;
  align-items: center;
}
.stepItem .iconClass{
  width: 18px;
  height: 18px;
}
.stepItem .iconClass img{
  width: 18px;
  height: 18px;
}
.stepItem .line{
  width: 100%;
  height: 2px;
  background: #ECECEC;
}
.stepItem:last-child{
  flex-shrink: 0;
  flex-grow: 0;
}
.cricle{
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #D62D27;
  position: absolute;
  top:0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  /* margin-top: 5px; */
}
.pr{
  position: relative;
  height: 18px;
  width: 18px;
  margin: auto;
}
.patitle{
  position: absolute;
  left: -20px;
  top: 20px;
  width: 55px;
  height: 35px;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  color: #333333;
  line-height: 35px;
}
.activeLine{
  background:#D62D27 !important ;
}

.next {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  /* position: fixed; */
  /* position: static; */
  /* bottom: 0; */
  width: 100%;
  height: 60px;
  padding: 0 10px;
  background-color: #fff;
}
.next .nextBtn {
  background-color: red;
  border: none;
  font-size: 18px;
  font-weight: bold;
}
.prevBtn {
  border-color: red;
  color: red;
}


</style>